export default "__VITE_ASSET__C$ESJ3Ie__"